module.exports = __webpack_public_path__ + "static/media/5.0684b851.jpg";